import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Home/ServicesSection.css';

const ServicesSection = () => {
  const services = [
    { id: 1, icon: 'bi-laptop', title: 'IT Services', description: 'IT infrastructure management and enterprise support.' },
    { id: 2, icon: 'bi-cloud', title: 'Cloud Computing', description: 'Cloud migration, deployment, and optimization services.' },
    { id: 3, icon: 'bi-shield-check', title: 'Cyber Security', description: 'End-to-end protection for systems and networks.' },
    { id: 4, icon: 'bi-headset', title: 'IT Support', description: '24/7 helpdesk and technical support services.' },
    { id: 5, icon: 'bi-hdd-stack', title: 'IT Products', description: 'Hardware and software solutions for businesses.' },
    { id: 6, icon: 'bi-code-square', title: 'Software Solutions', description: 'Custom and enterprise software development.' },
    { id: 7, icon: 'bi-people', title: 'Placements', description: 'IT staffing and placement services.' }
  ];

  return (
    <section className="services-section section-padding">
      <div className="container">
        <div className="section-header text-center mb-5">
          <span className="section-label">Our Services</span>
          <h2 className="section-title">IT Solutions We Offer</h2>
        </div>

        <div className="services-grid">
          {services.map(service => (
            <div className="service-card" key={service.id}>
              <div className="service-icon">
                <i className={`bi ${service.icon}`}></i>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <Link to="/services" className="service-link">
                Learn More <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
